import React from "react";
import RankingsTable from "../components/Rankings/RankingsTable";


const Rankings = () => {
    console.log("Rankings page loaded");
    return (
        <RankingsTable />
    );
}

export default Rankings;
